/**
 * Data access for the referrals entity.
 *
 * Reads ``GET /api/referrals/invited/`` — the current user's invited users with each
 * invitee's purchase history and the star glitter (ЗБ) the user earned from them (ТЗ №2 §7).
 * The list is scoped server-side to the authenticated Telegram user.
 */
import { useApiQuery, type QueryState } from "@shared/api";

import type { InvitedUser } from "./model";

/** Path of the invited-users endpoint. */
export const INVITED_PATH = "/referrals/invited/";

/** Fetch the current user's invited users (server-scoped). */
export function useInvitedUsers(): QueryState<readonly InvitedUser[]> {
  return useApiQuery<readonly InvitedUser[]>(INVITED_PATH);
}
